import React from "react";
import { Outlet } from "react-router-dom";
import SubFooter from "../components/landingPage/footer/SubFooter";
import { useSelector } from "react-redux";
//import Navbar from '../components/landingPage/header/Navbar'

// This Layout render pages with CTA section(SubFooter section) and footer

const LandingPagesHTF = () => {
  const { isInvitationActive = false } = useSelector(
    (state) => state?.invitationListEmails
  );
  const users = localStorage.getItem("user")
    ? JSON.parse(localStorage.getItem("user"))
    : null;

  const userToken = users?.token;
  return (
    <>
      {/* <Navbar /> */}
      <div className="min-h-[calc(100vh_-_50vh)]">
        <Outlet />
      </div>
      <>{!userToken && isInvitationActive === true ? null : <SubFooter />}</>
    </>
  );
};

export default LandingPagesHTF;
